(function goodDeedsContactForm() {
  'use strict';

  function isVisible(field) {
    if (!field || field.disabled || field.hidden || field.type === 'hidden') return false;
    if (field.closest('[hidden], [aria-hidden="true"], [inert]')) return false;

    if (typeof window.getComputedStyle === 'function') {
      var style = window.getComputedStyle(field);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }

    return typeof field.getClientRects !== 'function' || field.getClientRects().length > 0;
  }

  function activateContactForm(form) {
    if (!form || form.dataset.gdContactReady === 'true') return;
    form.dataset.gdContactReady = 'true';

    var submit = form.querySelector('[data-gd-contact-submit], button[type="submit"]');
    var feedback = form.querySelector('[data-gd-contact-feedback]');
    var success = form.querySelector('[data-gd-contact-success]');

    if (!submit || !feedback) return;

    function fields() {
      return Array.prototype.slice.call(form.querySelectorAll('input, select, textarea'));
    }

    function syncRequiredFields() {
      fields().forEach(function (field) {
        if (field.type === 'hidden') return;

        if (!isVisible(field) && field.required) {
          field.dataset.gdRequiredWhenVisible = 'true';
          field.required = false;
        } else if (isVisible(field) && field.dataset.gdRequiredWhenVisible === 'true') {
          field.required = true;
          delete field.dataset.gdRequiredWhenVisible;
        }
      });
    }

    function firstInvalidField() {
      return fields().find(function (field) {
        return isVisible(field) && field.willValidate !== false && field.validity && !field.validity.valid;
      });
    }

    function validationMessage(field) {
      if (field.name === 'contact[email]') {
        return field.validity.valueMissing
          ? 'Please enter your email address so we can reply.'
          : 'Please enter a valid email address.';
      }
      if (field.name === 'contact[Topic]') return 'Please choose what your question is about.';
      if (field.name === 'contact[body]') return 'Please tell us what you need help with.';
      return 'Please complete this field before sending your question.';
    }

    function showInvalidField(field) {
      if (!field || !isVisible(field)) return;

      var message = validationMessage(field);
      var container = field.closest('.gd-contact-field');
      var fieldError = container && container.querySelector('[data-gd-contact-field-error]');

      feedback.hidden = false;
      feedback.dataset.gdState = 'error';
      feedback.setAttribute('role', 'alert');
      feedback.textContent = message;
      field.setAttribute('aria-invalid', 'true');

      if (fieldError) {
        fieldError.hidden = false;
        fieldError.textContent = message;
        if (fieldError.id) field.setAttribute('aria-describedby', fieldError.id);
      }

      if (typeof field.focus === 'function') field.focus();
      if (typeof field.scrollIntoView === 'function') {
        field.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    function clearFieldError(event) {
      var field = event.target;
      if (!field || !field.validity || !field.validity.valid) return;

      var container = field.closest('.gd-contact-field');
      var fieldError = container && container.querySelector('[data-gd-contact-field-error]');
      field.removeAttribute('aria-invalid');

      if (fieldError) {
        fieldError.hidden = true;
        fieldError.textContent = '';
        if (field.getAttribute('aria-describedby') === fieldError.id) field.removeAttribute('aria-describedby');
      }

      if (!form.querySelector('[aria-invalid="true"]') && feedback.dataset.gdState === 'error') {
        feedback.hidden = true;
        feedback.textContent = '';
      }
    }

    submit.addEventListener('click', function (event) {
      syncRequiredFields();

      var invalidField = firstInvalidField();
      if (!invalidField) return;

      event.preventDefault();
      showInvalidField(invalidField);
    });

    form.addEventListener('invalid', function (event) {
      if (!isVisible(event.target)) {
        event.target.dataset.gdRequiredWhenVisible = 'true';
        event.target.required = false;
        return;
      }

      event.preventDefault();
      showInvalidField(event.target);
    }, true);

    form.addEventListener('input', clearFieldError);
    form.addEventListener('change', clearFieldError);

    form.addEventListener('submit', function (event) {
      syncRequiredFields();
      var invalidField = firstInvalidField();

      if (invalidField) {
        event.preventDefault();
        showInvalidField(invalidField);
        return;
      }

      feedback.hidden = false;
      feedback.dataset.gdState = 'sending';
      feedback.setAttribute('role', 'status');
      feedback.textContent = 'Sending your message to Good Deeds…';
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = 'Sending your question…';
    });

    if (success && typeof success.focus === 'function') {
      window.setTimeout(function () {
        success.focus();
        if (typeof success.scrollIntoView === 'function') success.scrollIntoView({ block: 'center' });
      }, 0);
    }
  }

  function activateAll() {
    document.querySelectorAll('form.gd-contact-form').forEach(activateContactForm);
  }

  activateAll();
  document.addEventListener('shopify:section:load', activateAll);
})();
